import { useContext } from 'react'

import BrandingContext from '../../../context/BrandingContext'

type Props = {
  checked: boolean
  onChange: () => void
}

const BuildEgtDisclaimer = (props: Props) => {
  const { checked, onChange } = props
  const [branding] = useContext(BrandingContext)
  const { primaryColorPalette } = branding

  return (
    <div className="rounded-md border border-orange-200 bg-orange-50 p-4">
      <div>
        <h5 className="text-sm font-semibold text-black">EGT off disclaimer</h5>
        <p className="mt-1 text-xs text-gray-700">
          By selecting the &quot;EGT off&quot; option, you accept all
          responsibility for any mechanical failures after the modified file is
          written in. EGT sensor delete can sometimes cause erratic idle issues
          and engine failures on certain vehicles. We accept no responsibility
          for any issues.
        </p>
      </div>
      <div className="mt-4 flex items-center gap-3">
        <input
          id="build-egt-disclaimer"
          className={`h-5 w-5 rounded-md border-gray-400 text-${primaryColorPalette}-600`}
          type="checkbox"
          onChange={onChange}
          checked={checked}
        />
        <label
          className="text-sm underline cursor-pointer"
          htmlFor="build-egt-disclaimer"
        >
          I agree to this EGT off disclaimer
        </label>
      </div>
    </div>
  )
}

export default BuildEgtDisclaimer
